export default __webpack_public_path__ + "static/1814-0f7b31fa05d589856d364999f010ed88.jpg";